/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Layout, Card, Table, Tag } from "antd";

import { getAPI } from "../../../utils/common";
import { STOCK_REPORT } from "../../../constants/api";

const { Content } = Layout;

function StockReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    getAPI(
      STOCK_REPORT,
      (res) => {
        if (res.status === true) {
          const formatted = res.data.map((row, index) => ({
            key: index,
            Item: row.item.name,
            Opening: row.opening_qty,
            Current: row.current_qty,
            Status:
              row.current_qty <= 10 ? (
                <Tag color="red">Low Stock</Tag>
              ) : (
                <Tag color="green">Available</Tag>
              ),
          }));
          setData(formatted);
        }
        setLoading(false);
      },
      () => setLoading(false),
      {}
    );
  }, []);

  const columns = [
    { title: "Item Name", dataIndex: "Item", width: 250 },
    { title: "Opening Qty", dataIndex: "Opening", width: 150 },
    { title: "Current Qty", dataIndex: "Current", width: 150 },
    { title: "Status", dataIndex: "Status", width: 150 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card title="Laundry Stock Report">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default StockReport;
